import React from 'react';
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {countriesConstants, datesConstants, statesConstants} from "mindsets-js-sdk";

import TeachersCount from "./TeachersCount";
import SchoolSubscriptionPeriod from "./SchoolSubscriptionPeriod";
import DistrictSubscriptionPeriod from "./DistrictSubscriptionPeriod";
import EditSchoolButton from "./EditSchoolButton";
import DeleteButton from "./DeleteButton";

function Row({item, row_number, curriculum}) {
    let location = [];
    if (item.location) {
        location.push(item.location);
    }
    if (item.city) {
        if (location.length > 0) {
            location.push(', ');
        }
        location.push(item.city);
    }
    if (statesConstants.STATES.hasOwnProperty(item.country)) {
        if (location.length > 0) {
            location.push(', ');
        }
        location.push(statesConstants.STATES[item.country][item.state]);
    }
    if (item.district) {
        if (location.length > 0) {
            location.push(', ');
        }
        location.push(<Link
            key={item.district.id}
            to={'/districts/' + item.district.id}
            data-bs-toggle="tooltip"
            data-placement="top"
            title="Edit district"
        >{item.district.name}</Link>);
    }
    if (item.country && countriesConstants.COUNTRIES.hasOwnProperty(item.country)) {
        if (location.length > 0) {
            location.push(', ');
        }
        location.push(countriesConstants.COUNTRIES[item.country]);
    }
    if (item.zip) {
        if (location.length > 0) {
            location.push(', ');
        }
        location.push(item.zip);
    }
    if (item.phone) {
        if (location.length > 0) {
            location.push(', ');
        }
        location.push('ph. ' + item.phone);
    }

    function renderCityMismatch() {
        if (item.district && item.district.city && item.city && item.district.city.toLowerCase() !== item.city.toLowerCase()) {
            return (
                <div className='text-danger'>
                    City name of the school({item.city}) does not match the city name of the School
                    District({item.district.city})
                </div>
            );
        }

        return null;
    }

    function renderStateMismatch() {
        if (item.district && item.district.state && item.state && item.district.state !== item.state) {
            return (
                <div className='text-danger'>
                    State of the school({item.state}) does not match the state of the School
                    District({item.district.state})
                </div>
            );
        }

        return null;
    }

    function renderNCESID() {
        if (item.nces_id) {
            return (
                <div>({item.nces_id})</div>
            );
        }

        return null;
    }

    function renderCreatedBy() {
        if (item.user) {
            return (
                <div>{item.user.fname} {item.user.lname} ({item.user.email})</div>
            );
        }

        return (
            <div>Imported</div>
        );
    }

    return (
        <tr key={item.id}>
            <td>{row_number}</td>
            <td>
                {item.id}
                {renderNCESID()}
            </td>
            <td>{item.name}</td>
            <td>
                {location}
                {renderStateMismatch()}
                {renderCityMismatch()}
            </td>
            <td>{curriculum ? curriculum.name : 'Not selected'}</td>
            <td className="text-center"><TeachersCount item={item}/></td>
            <td className="text-center">{item.students_count}</td>
            <td className="text-center">{item.lessons_count}</td>
            <td><SchoolSubscriptionPeriod school={item}/></td>
            <td><DistrictSubscriptionPeriod school={item}/></td>
            <td>
                {renderCreatedBy()}
                {new Date(item.created_at * 1000).toLocaleDateString('en-US', datesConstants.US_DATE_FORMAT)}
            </td>
            <td>
                <div className='d-flex flex-gap-5'>
                    <EditSchoolButton id={item.id}/>
                    <DeleteButton id={item.id}/>
                </div>
            </td>
        </tr>
    );
}

Row.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        teachers_count: PropTypes.number.isRequired,
        students_count: PropTypes.number.isRequired,
        lessons_count: PropTypes.number.isRequired,
        country: PropTypes.string,
        state: PropTypes.string,
        city: PropTypes.string,
        zip: PropTypes.string,
        nces_id: PropTypes.string,
        phone: PropTypes.string,
        created_at: PropTypes.number,
        curriculum_id: PropTypes.number,
        district: PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        }),
        user: PropTypes.shape({
            id: PropTypes.number.isRequired,
            email: PropTypes.string.isRequired,
            fname: PropTypes.string,
            lname: PropTypes.string,
        })
    }).isRequired,
    curriculum: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }),
    row_number: PropTypes.number.isRequired,
};

export default Row;
